import { WrapperImage } from "~~/types/cms"

export enum BadgeType {
  sopOtc = "sopOtc",
  vet = "vet"
}

export interface MinisterialBadge {
  title: string
  ministerialLink: string
  image: WrapperImage
  badgeType: BadgeType
}

export interface ComponentMinisterialBadgesProps {
  Badges: MinisterialBadge[]
  classImage?: string
}
